/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var moment = require('moment');

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function(data) {
  var defer = $.Deferred();

  $.soap({
    body: {
      SubmitCompliance: {
        $xmlns: 'http://dobs.pa.gov/sc/compliance/bpm/1.0',
        ComplianceID: data.complianceId,
        ObjectID: data.objectId,
        ObjectTypeID: data.objectTypeId,
        ActionTypeID: data.actionTypeId,
        OtherActionTypeID: data.otherActionTypeId,
        IssuedDate: data.issuedDate ? moment(data.issuedDate, 'MM-DD-YYYY').format('YYYY-MM-DD') : null,
        IsRegistered: data.isRegistered,
        OGCDocketNumber: data.ogcDocketNumber,
        OrderStatusID: data.orderStatusId,
        CriminalAuthActionID: data.criminalAuthActionId,
        CivilAuthActionID: data.civilAuthActionId,
        IsDeleted: data.isDeleted
      }
    },
    blueprint: {
      newComplianceId: '$..NewComplianceID'
    }
  })
    .done(function(response) {
      cleanUpResponse(response);
      defer.resolve(response.newComplianceId);
    })
    .fail(function(err) {
      defer.reject(err);
    });

  return defer.promise();
};
